import { ReactNode } from 'react';
import NativeLink from 'next/link';
import { UrlObject } from 'url';
import { twJoin } from 'tailwind-merge';

interface Props {
    href: string | UrlObject;
    children: ReactNode;
    rightAddon?: ReactNode;
    className?: string;
}

export function Link({ href, children, rightAddon, className }: Props) {
    return (
        <NativeLink href={href} className={twJoin('text-sm font-medium text-primary-500', className)}>
            <span className="inline-flex items-center gap-2">
                <span>{children}</span>
                {rightAddon != null && rightAddon}
            </span>
        </NativeLink>
    );
}
